var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.show == '1')?_c('div',{staticClass:"closs"},[_c('p'),_c('p'),_c('p',[_vm._v("系统已关闭。")]),_c('img',{attrs:{"src":require("./assets/tips.png"),"alt":""}})]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }